import {useState,useEffect} from "react";
import { Link, useLocation, useOutletContext } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import MgpStore from "Stores/Store";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import { Helmet } from "react-helmet-async";
import ApiError from "Utils/ApiError";
import { sanitizeContent } from "Utils/sanitizeConfig";
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
const GameDownUi = ({gameSvcCd,ctntCtgrCd,ctntCtgrCdName,LstType}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const { push: gtmPush } = useGtm();
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const location = useLocation();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd") || "MGP";
    let test1:any;
    
    // 유저 에이전트에 따라 다운로드 URL 결정
    const getUserAgent = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.includes('mac') || userAgent.includes('macintosh')) {
            return 'mac';
        }
        return 'win';
    };
    
    const downUrl = getUserAgent() === 'mac' 
        ? gameMainPageData?.gameSvcUiInfo?.macLnchDwnldUrl 
        : gameMainPageData?.gameSvcUiInfo?.winLnchDwnldUrl;

    const handleDownloadClick = () => {
        const os = getUserAgent() === 'mac' ? 'MAC' : 'WIN';
        const tsKst = getKstTimestamp();
        const adPayload = fetchAdPayload( getGameSvcCd||'BBO');

        if (window.fbq) {
            window.fbq('trackCustom', 'BBO_FB_Game_Download');
        }

        try {

            gtmPush('BBO_GA_Game_Download', {
                ts: tsKst,
                ...adPayload,
                OS: os,
            });
        } catch (gtmErr) {
            if (typeof window !== 'undefined') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'BBO_GA_Game_Download',
                    ts: tsKst,
                    ...adPayload,
                    OS: os,
                });
            }
        }
    };
    
    useEffect(()=>{
        EtcCtxtApi("CTNT_KIND_ETC","GAME_DWNLD_SPEC",getGameSvcCd).then((resp)=>{
            switch(resp.apiHdr.code){
                case "COMM0000":
                    const dirty = resp.apiBody.ctxt;
                    test1 = sanitizeContent(dirty);
                    setCtntCtxtState(test1);
                break;
                default:
                    ApiError(langData,resp.apiHdr.code);
                break;
            }
        });
      },[MgpStore.getState().LangSetState.Lang])
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntCtgrCd);
    return(
        <>,
        <Helmet>    
            <title>{`BE@RBRICK HEROES - 다운로드`}</title>
        </Helmet>
        <div className="BgW">
            <div 
            className="csMainBnr newsMainBnr downBnr" 
            >
                <img src={`https://bb-cdn.onuniverse.io/web/mainpage/downSubBnr.jpg`} alt="" />
                <div className="ctxtWrap">
                    <div className="ctxtCenterWrap">
                        <div>
                            {/*<h1>베어브릭 히어로즈 런처 다운로드</h1>*/}
                            <h1>{langData&&langData.GAME_DWNLD_TITL_00}</h1>
                            {/*<p>베어브릭 히어로즈를 즐기시기 위해선 런처 파일을 다운로드 받아 설치해 주시기 바랍니다.</p>*/}
                            <p>{langData&&langData.GAME_DWNLD_DESC_00}</p>
                        </div>
                        <div>
                            <a href={downUrl} className="downloadBtn" onClick={handleDownloadClick}>
                                {/*<p>런처 다운로드</p>*/}
                                <p>{langData&&langData.GAME_DWNLD_DL_BTN_00}</p>
                            </a>
                            <ul  className='deviceIconWrap'>
                                <li>
                                    <img src={process.env.PUBLIC_URL + "/images/Mainpage/WindowIcon.png"} alt="" />
                                </li>
                                <li>
                                    <img src={process.env.PUBLIC_URL + "/images/Mainpage/MacIcon.png"} alt="" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="ctxtBottomWrap"> 
                        <ul>
                            <a href="https://discord.com/invite/H6aeYKyAa3" target="_blank">
                                {/*<p>커뮤니티</p>*/}
                                <p>{langData&&langData.GAME_DWNLD_COMM_BTN_00}</p>
                            </a>
                            <li>
                                <a href={`/GamePage/GameGuide?gameSvcCd=${getGameSvcCd}&ctntKindCd=GGUID`}>
                                    {/*<p>게임 가이드</p>*/}
                                    <p>{langData&&langData.GAME_DWNLD_GUIDE_BTN_00}</p>
                                </a>
                            </li>
                            <a href={`/cs/FaqLst?gameSvcCd=${getGameSvcCd}&ctntKindCd=FAQ`} target="_blank">
                                <p>FAQ</p>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container1400">
                <div className="downSpecWrap">
                    {/*<h2>베어브릭 히어로즈 시스템 사양</h2>*/}
                    <h2>{langData&&langData.GAME_DWNLD_SPEC_TITL_00}</h2>
                    <div className="mt10"
                    dangerouslySetInnerHTML={{
                        __html: ctntCtxtState,
                    }}>  
                        
                    </div>
                </div>
                <div  className="downSpecWrap">
                    {/*<h2>드라이버 다운로드</h2>*/}
                    <h2>{langData&&langData.GAME_DWNLD_DRV_TITL_00}</h2>
                    <ul className="driverUl">
                        <li>
                            <a href="https://www.nvidia.com/ko-kr/drivers/"target="_blank">
                                <div className="imgWrap">
                                    <img src={process.env.PUBLIC_URL+'/images/common/nvidiaLogo.png'} alt="nvidiaLogo" className="nvidiaLogo" />
                                </div>
                                {/*<p>
                                    NVIDIA 그래픽 드라이버<br />
                                    다운로드
                                </p>*/}
                                <p>
                                    {langData&&langData.GAME_DWNLD_NVIDIA_DRV_00}<br />
                                    {langData&&langData.GAME_DWNLD_DL_BTN_00}
                                </p>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.amd.com/ko/support/download/drivers.html"target="_blank">
                                <div className="imgWrap">
                                    <img src={process.env.PUBLIC_URL+'/images/common/amdLogo.png'} alt="amdLogo"  className="amdLogo" />
                                </div>
                                {/*<p>
                                    AMD 그래픽 드라이버<br />
                                    다운로드
                                </p>*/}
                                <p>
                                    {langData&&langData.GAME_DWNLD_AMD_DRV_00}<br />
                                    {langData&&langData.GAME_DWNLD_DL_BTN_00}
                                </p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        </>
    )
}
export default GameDownUi;